import { createContext } from 'react';
import { makeObservable, observable, action } from 'mobx';

export const MeasurementModalStateContext = createContext(null);

export class MeasurementModalState {
    measurement = null;
    constructor() {
        makeObservable(this, {
            measurement: observable,
            show: action,
            close: action,
        });
    }
    show(measurement) {
        this.measurement = measurement;
    }
    close() {
        this.measurement = null;
    }
}
